/**
 * Created by PhpStorm.
 * Copyright: David Obdržálek, Carpe Noctem, s.r.o.
 * Date: 2019-01-22 16:19
 */

include('inc/jquery-3.6.0.min.js');
include('inc/jquery.autosize.min.js');
include('inc/owl.carousel.min.js');
include('inc/carpe.basic.js');
include('inc/carpe.fx.js');
include('inc/carpe.socgal.js');

// $.fn.loadBoxMenu = function() {
//   let url = $(this).data('url');
//   if (!url) return;
//
//   $.ajax(url)
//   .always((resp, status) => {
//     if (status !== 'success' || typeof resp !== 'object' || !resp.length)
//       return;
//
//     resp.forEach(category => {
//       let target = $(`[data-category="${category.name}"]`);
//       if (!target.length) return;
//
//       target.removeClass('loading');
//       target.append($('<h4>').text(category.name));
//
//       (category['products'] || []).forEach(item => {
//         let name = Carpe.lang === 'cs' ? item.name : (item.description || item.name);
//         $('<p class="item" />')
//             .append($('<span class="name">').text(name))
//             .append($('<span class="price">').text(item['price_vat'] ? item['price_vat'].price('CZK', 0) : ''))
//             .appendTo(target);
//       });
//     });
//   });
//   return this;
// };

// $.fn.loadMenu = function() {
//   let url = $(this).data('url');
//   if (!url) return;
//
//   $.ajax(url)
//   .always((resp, status) => {
//     if (status !== 'success' || typeof resp !== 'object' || !resp.length)
//       return;
//
//     $(this).removeClass('loading');
//     resp.forEach(category => {
//       if (!category['products'] || !category['products'].length)
//         return;
//
//       let target = $('<div class="category">').appendTo($(this));
//
//       target.append($('<h4>').text(category.name));
//
//       let table = $('<table>').appendTo(target);
//       category['products'].forEach(item => {
//         let name = Carpe.lang === 'cs' ? item.name : (item.description || item.name);
//         $('<tr>')
//             .append($('<td class="name">').text(name))
//             .append($('<td class="price">').text(item['price_vat'] ? item['price_vat'].price('CZK', 0) : ''))
//             .appendTo(table);
//       });
//     });
//   });
//   return this;
// };

$.fn.anonymaps = function(options) {
  options = options || {};
  let key = options.key || $(this).data('apikey');

  if (!key) return;
  let div = $('<div class="map" />').appendTo($(this));
  let styles = options.styles ? $.getJSON({url: options.styles, async: false}).responseJSON : null;

  window.initMap = function() {
    let map = new google.maps.Map(div[0], {
      center: {lat: 50.083, lng: 14.4211},
      zoom: 15, disableDefaultUI: true,
      styles: styles, backgroundColor: 'none'
    });

    let markers = {};
    let tooltips = {
      "Michalská":
          "<strong>AnonymouS Bar</strong><br />" + "\n" +
          "Michalská 12, Prague 1<br />" + "\n" +
          "<a href='//www.anonymousbar.cz/' class='noa'>www.anonymousbar.cz</a>" + "\n" +
          "<br /><br />" + "\n" +
          "<a href='//maps.google.com/?q=Michalská+12,+Prague' target='_blank'>Open in Maps</a>",
      "Jungmannova":
          "<strong>Shrink's Office</strong><br />" + "\n" +
          "Jungmannova 11, Prague 1<br />" + "\n" +
          "<a href='//www.shrinksoffice.cz/' class='noa'>www.shrinksoffice.cz</a>" + "\n" +
          "<br /><br />" + "\n" +
          "<strong>Ideas are Bulletproof</strong><br />" + "\n" +
          "Jungmannova 11, Prague 1<br />" + "\n" +
          "<a href='//www.bulletproofbar.cz/' class='noa'>www.bulletproofbar.cz</a>" + "\n" +
          "<br /><br />" + "\n" +
          "<a href='//maps.google.com/?q=Jungmannova+11,+Prague' target='_blank'>Open in Maps</a>"
    };
    let tooltip = new google.maps.InfoWindow();
    setTimeout(() => {
      markers['Michalská'] = new google.maps.Marker({
        position: {lat: 50.0854, lng: 14.42},
        title: "AnonymouS Bar",
        animation: google.maps.Animation.DROP,
        icon: { url: '/images/marker.svg', scaledSize: new google.maps.Size(32, 32) },
        map: map});
      markers['Michalská'].addListener('click', () => {
        tooltip.setContent(tooltips['Michalská']);
        tooltip.open(map, markers['Michalská']);
      });
    }, 500);
    setTimeout(() => {
      markers['Jungmannova'] = new google.maps.Marker({
        position: {lat: 50.0804, lng: 14.4222},
        title: "Shrink's Office" + "\n" + "& Bulletproof Bar",
        animation: google.maps.Animation.DROP,
        icon: { url: '/images/marker.svg', scaledSize: new google.maps.Size(32, 32) },
        map: map});
      markers['Jungmannova'].addListener('click', () => {
        tooltip.setContent(tooltips['Jungmannova']);
        tooltip.open(map, markers['Jungmannova']);
      });
    }, 1000);
  };

  $(this).append(`<script src="https://maps.googleapis.com/maps/api/js?key=${key}&callback=initMap" async defer></script>`)
  return this;
};

$(() => {
  $('nav menu a[href^="#"]').on('click', function(e) {
    $('nav').removeClass('open');
    $(window).trigger('hashchange', this.hash || $(this).attr('href'));
    e.stop();
  });

  // $('#scroll-menucard').on('appear', function() {
  //   $(this).loadBoxMenu();
  // });

  // #scroll-media
  (() => {
    let wi = $('#scroll-media .biglinks .item').first().outerWidth(true) * $('#scroll-media .biglinks .item').length;
    if (wi > $(window).width()) {
      $('#scroll-media .biglinks').addClass('owl-carousel').owlCarousel({
        autoWidth: true, nav: false, dots: true
      });
    } else {
      $('#scroll-media .biglinks').addClass('middle');
    }

  })();


});